import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; 



const ProtectedRoute = ({ element: Element }) => {
  const { isAuthenticated, isChecking } = useAuth();

  if (isChecking) {
      return <div>Loading...</div>; // You could replace this with a spinner or other loading indicator
  }

  // Render the element if authenticated, otherwise navigate to the login page
  return isAuthenticated ? (
      Element // Render the JSX element directly
  ) : (
      <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;


